import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

export const districtMessage = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  margin: 0,
});

export const tabPanelStack = css({
  display: 'grid',
  gridTemplateAreas: '"stack"',
  marginTop: 'default',
});

export const tabPanel = css({
  gridArea: 'stack',
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const tabPanelInactive = css({
  visibility: 'hidden',
  pointerEvents: 'none',
});

export const schoolList = css({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const schoolItem = css({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  alignItems: 'center',
  gap: 'default',
  paddingTop: 'default',
  paddingBottom: 'default',
  borderTopWidth: 'default',
  borderTopStyle: 'solid',
  borderTopColor: 'border.neutral',
  '&:first-of-type': {
    borderTopWidth: 0,
    paddingTop: 0,
  },
});

export const schoolItemFocusTarget = css({
  outline: 'none',
});

export const ratingBadge = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '800',
  height: '800',
  borderRadius: '50%',
  background: 'bg.accent.brand.hero-fixed',
  color: 'white',
  fontSize: 'body-sm',
  fontWeight: 'bold',
});

export const ratingBadgeMuted = css({
  background: 'bg.softest',
  color: 'text.subtle',
});

export const schoolBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
  minWidth: 0,
});

export const schoolName = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  fontWeight: 'bold',
  margin: 0,
});

export const link = css({
  color: 'text.accent.brand.hero',
  textDecoration: 'none',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});

export const schoolMeta = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.subtle',
  margin: 0,
});

export const schoolDistance = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.subtle',
  whiteSpace: 'nowrap',
});

export const showingMessage = css({
  fontSize: 'body-xs',
  lineHeight: 'body-sm',
  color: 'text.subtle',
  margin: 0,
});

export const showMoreButton = css({
  alignSelf: 'flex-start',
  background: 'transparent',
  border: 'none',
  padding: 0,
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.accent.brand.hero',
  fontWeight: 'regular',
  cursor: 'pointer',
  _hover: {
    textDecoration: 'underline',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
    borderRadius: 'sm',
  },
});

export const disclaimer = css({
  fontSize: 'body-xs',
  lineHeight: 'body-sm',
  color: 'text.subtle',
  margin: 0,
});

export const disclaimerPanel = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  marginBlock: 'tighter',
});

export const disclaimerHeading = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.neutral',
  fontWeight: 'bold',
  margin: 0,
});

export const disclaimerSection = css({
  fontSize: 'body-xs',
  lineHeight: 'body-sm',
  color: 'text.subtle',
  margin: 0,
});

export const srOnly = css({
  position: 'absolute',
  // eslint-disable-next-line hotpads/no-magic-numbers -- standard visually-hidden box size
  width: '1px',
  // eslint-disable-next-line hotpads/no-magic-numbers -- standard visually-hidden box size
  height: '1px',
  padding: 0,
  // eslint-disable-next-line hotpads/no-magic-numbers -- standard visually-hidden offset
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
